export default {
  title: 'Timezone',
  currentTime: 'Current time',
  pinned: 'Frequently used',
  prev: 'Previous timezone',
  next: 'Next timezone',
  confirm: 'Apply',
  hint: 'Scroll or use arrow keys to switch timezone; the page reloads after applying',
  cities: {
    m720: 'International Date Line West',
    m660: 'Midway Island',
    m600: 'Hawaii',
    m540: 'Alaska',
    m480: 'Tijuana, Baja California, Pacific Time (US & Canada)',
    m420: 'Arizona, Chihuahua, La Paz, Mazatlan, Mountain Time (US & Canada)',
    m360: 'Guadalajara, Mexico City, Monterrey, Saskatchewan, Central America, Central Time (US & Canada)',
    m300: 'Indiana (East), Bogota, Lima, Quito, Eastern Time (US & Canada), Caracas',
    m240: 'Asuncion, Santiago, Georgetown, La Paz, San Juan, Manaus, Atlantic Time (Canada), Newfoundland',
    m180: 'Cayenne, Greenland, Buenos Aires, Brasilia, Montevideo',
    m120: 'Mid-Atlantic',
    m60: 'Azores, Cape Verde Islands',
    p0: 'Casablanca, Dublin, Edinburgh, Lisbon, London, Monrovia, Reykjavik, UTC',
    p60: 'Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna, Sarajevo, Skopje, Warsaw, Zagreb, Brussels, Copenhagen, Madrid, Paris, Belgrade, Bratislava, Budapest, Ljubljana, Prague, West Central Africa',
    p120: 'Athens, Bucharest, Istanbul, Amman, Windhoek, Jerusalem, Cairo, Harare, Pretoria, Beirut, Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius, Minsk',
    p180: 'Kuwait, Riyadh, Tbilisi, Nairobi, Baghdad, Moscow, St. Petersburg, Volgograd, Tehran',
    p240: 'Abu Dhabi, Muscat, Yerevan, Baku, Port Louis, Kabul',
    p300: 'Islamabad, Karachi, Yekaterinburg, Tashkent, Sri Jayawardenepura, Chennai, Kolkata, Mumbai, New Delhi, Kathmandu',
    p360: 'Astana, Dhaka, Almaty, Novosibirsk, Yangon',
    p420: 'Krasnoyarsk, Bangkok, Hanoi, Jakarta',
    p480: 'Irkutsk, Ulaanbaatar, Kuala Lumpur, Singapore, Perth, Taipei, Beijing, Chongqing, Hong Kong SAR, Urumqi',
    p540: 'Seoul, Yakutsk, Osaka, Sapporo, Tokyo, Adelaide, Darwin',
    p600: 'Vladivostok, Canberra, Melbourne, Sydney, Guam, Port Moresby, Brisbane, Hobart',
    p660: 'Magadan, Solomon Islands, New Caledonia',
    p720: 'Auckland, Wellington, Fiji, Marshall Islands, Petropavlovsk-Kamchatsky',
    p780: 'Samoa, Nukualofa',
    p840: 'Kiritimati, Line Islands'
  }
};
